import React from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../REDUX/actions/confirmationModal";
import CustomButton from "../Common/CustomButton";
import { useNavigate } from "react-router-dom";
import {
  deletePartenaire,
  publishOrNoPublishPartenaire,
} from "../../REDUX/actions/partenaire";
import { Form } from "react-bootstrap";

const PartenaireCard = ({ partenaire, index }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(deletePartenaire(partenaire.id));
  };
  const showModalPublish = (checked) => {
    dispatch(
      openModal({
        confirmButtonText: checked ? "Publier" : "Retirer",
        cancelButton: true,
        message: checked
          ? "Êtes-vous sûr(e) de vouloir publier le partenaire ?"
          : "Êtes-vous sûr(e) de vouloir rendre le partenaire non publié ?",
        callBack: () =>
          dispatch(publishOrNoPublishPartenaire(partenaire.id, checked)),
      })
    );
  };
  const showModal = () =>
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer le partenaire ?",
        callBack: handleDelete,
      })
    );

  const goTo = () => {
    navigate(`/partenaire/${partenaire.id}`, { state: { id: partenaire.id } });
  };

  return (
    <div
      className={`w-98 mx-auto my-2 row py-4 align-items-center rounded-10 ${
        index % 2 === 0 ? "bg-lightGrey" : ""
      }`}
    >
      <div className="col-2 text-start">
        <div className="f14 bolder">#{partenaire?.id}</div>{" "}
        {partenaire?.attributes.name}
      </div>
      <div className="col-3 text-start">
        <div>{partenaire?.attributes.adress.data.attributes.fullAdress}</div>
        <div>{partenaire?.attributes.adress.data.attributes.postalCode}</div>
        <div>{partenaire?.attributes.adress.data.attributes.city}</div>
        <div>{partenaire?.attributes.adress.data.attributes.country}</div>
      </div>

      <div className="col-2 text-start">
        {partenaire?.attributes.partenaire_type || "Non défini"}
      </div>
      <div className="col-2 text-start">
        <Form.Check
          className="me-2"
          type="switch"
          checked={partenaire.attributes.publish}
          onChange={(e) => {
            e.preventDefault();
            showModalPublish(e.target.checked);
          }}
        />
      </div>
      <div className="col-3 text-start row justify-content-start">
        <div className="col-6">
          <CustomButton
            buttonText={"Modifier"}
            iconStart="pencil-fill"
            callBack={goTo}
          />
        </div>
        <div className="col-6">
          <CustomButton
            buttonText={"Supprimer"}
            type="red"
            iconStart="trash3-fill"
            callBack={showModal}
          />
        </div>
      </div>
    </div>
  );
};

export default PartenaireCard;
